export default "__VITE_ASSET__BjrNFaBf__"